import React, { useMemo, useRef, useState } from "react";
// @ts-ignore
import { StriimFormBuilder, FIELD_TYPES } from "@striim/striim-ui";
import TARGET_FORM_INFO from "src/modules/wizards/target/target-form-info";
import { validationUtils } from "src/modules/wizards/utils";
import FileBrowser from "src/generic/filebrowser-v2/filebrowser";
import ConnectionProfileSelector from "src/generic/connection-profile-selector/connection-profile-selector";

interface Props {
    targetType: string;
    initialValues?: Record<string, any>;
    source?: string;
    cdcSource?: string;
    onChange?: (values: Record<string, any>) => void;
    setFormValid?: (valid: boolean) => void;
    formRef?: React.MutableRefObject<any>;
}

const TargetFormConfigAI: React.FC<Props> = ({
    targetType,
    initialValues = {},
    source = "",
    cdcSource = "",
    onChange,
    setFormValid,
    formRef: externalFormRef
}) => {
    const internalFormRef = useRef<any>(null);
    const formRef = externalFormRef ?? internalFormRef;
    const [, setEnableNext] = useState(false);

    const isSourceModeAutomated = false;

    const formData = useMemo(
        () => (TARGET_FORM_INFO as any)[validationUtils.getTargetType(targetType).toUpperCase()]?.form_fields ?? [],
        [targetType]
    );

    const handleFormValid = (valid: boolean) => {
        setEnableNext(valid);
        setFormValid?.(valid);
    };

    return (
        // @ts-ignore — StriimFormBuilder types are incomplete
        <StriimFormBuilder
            formProps={{ isSourceModeAutomated, source, cdcSource }}
            initialFieldValues={initialValues}
            data={formData}
            onChange={onChange}
            validateOnChange={true}
            setFormValid={handleFormValid}
            formRef={formRef}
            setFieldToDefaultOnHidden={true}
            customFields={{
                [FIELD_TYPES.FILE]: (props: any) => <FileBrowser {...props} />,
                [FIELD_TYPES.CONNECTIONPROFILE]: (props: any) => <ConnectionProfileSelector {...props} />
            }}
        />
    );
};

export default TargetFormConfigAI;
